import { render, staticRenderFns } from "./MarketOnline.vue?vue&type=template&id=121fbea6&scoped=true&"
import script from "./MarketOnline.vue?vue&type=script&lang=js&"
export * from "./MarketOnline.vue?vue&type=script&lang=js&"
import style0 from "./MarketOnline.vue?vue&type=style&index=0&id=121fbea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121fbea6",
  null
  
)

export default component.exports